import {
  InlineNotification as SharedInlineNotification,
  InlineNotificationProps as SharedInlineNotificationProps,
} from "@flaminem/ui-components";
import { FC } from "react";

export type InlineNotificationProps = SharedInlineNotificationProps;

export const InlineNotification: FC<InlineNotificationProps> = ({ ...props }) => {
  return <SharedInlineNotification {...props} />;
};
